module.exports = __webpack_public_path__ + "img/hotel-1a.bf7302ee.jpg";